import { _ as __rest } from './tslib.es6-b97b9ccd.js';
import React__default from 'react';

const Spinner = (_a) => {
    var { size = 24, color, isMarryBaby } = _a, rest = __rest(_a, ["size", "color", "isMarryBaby"]);
    return (React__default.createElement("svg", Object.assign({ style: {
            display: 'block',
            shapeRendering: 'auto',
        }, width: size, height: size, viewBox: "30 30 40 40", preserveAspectRatio: "xMidYMid" }, rest),
        React__default.createElement("circle", { cx: "50", cy: "50", fill: "none", stroke: color || (isMarryBaby ? '#e85388' : '#91caff'), strokeWidth: "7", r: "16", strokeDasharray: "75.39822368615503 27.132741228718345" },
            React__default.createElement("animateTransform", { attributeName: "transform", type: "rotate", repeatCount: "indefinite", dur: "1.2s", values: "0 50 50;360 50 50", keyTimes: "0;1" }))));
};
Spinner.defaultProps = {
    size: 24,
};

export { Spinner as S };
